import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BizinBackend from "../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";
import { Col, Row, Alert } from "reactstrap";
import NotificationModal from "../../../components/Common/NotificationModal";
import TableSimple from "../../../components/Dynamic/TableSimple";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import CalendarMultiMonth from "../../../components/Common/CalendarMultiMonth";
import { isLoading } from "../../../store/layout/actions";


function GridBody() {
  const { access_token, userProfile } = useSelector((state) => ({
    access_token: state.login.user?.access_token,
    userProfile: state.login.profile
  }));

  const dispatch = useDispatch();

  const [step, setStep] = useState(1);

  const csrfToken = useGetCsrfToken();

  const [preFilter, setPreFilter] = useState([])
  const [locaisEntrega, setLocaisEntrega] = useState([])
  const [notasPesquisadas, setNotasPesquisadas] = useState(false)
  const [validacaoResults, setValidacaoResults] = useState([])
  const [validacaoExecutada, setValidacaoExecutada] = useState(false)
  const [agendaDisponivel, setAgendaDisponivel] = useState([])
  const [notasSelecionadas, setNotasSelecionadas] = useState([])
  const [notasGrid, setNotasGrid] = useState([])
  const [dataAgendaSelecionada, setDataAgendaSelecionada] = useState(null)
  const [horaAgendaSelecionada, setHoraAgendaSelecionada] = useState(null)
  const [showSchedules, setshowSchedules] = useState(true)
  const [modalConfirmacaoAberto, setModalConfirmacaoAberto] = useState(false)
  const [criandoAgendamento, setCriandoAgendamento] = useState(false)
  const [modalResultado, setModalResultado] = useState({ aberto: false, sucesso: false, mensagem: "", id: null, detalhes: null })

  const [comboBoxCategoriasOptions, setComboBoxCategoriasOptions] = useState([])
  const [comboBoxVeiculosOptions, setComboBoxVeiculosOptions] = useState([])
  const [comboBoxTiposEntregaOptions, setComboBoxTiposEntregaOptions] = useState([])

  const [isBlocked, setIsBlocked] = useState(false)

  const ID_DOCUMENTO_GRUPO = 2;

  const buildParamsBase = () => {
    const listaNotas = notasSelecionadas.map((n) => n.ID_Arquivo).join(",");
    const cnpjSelecionado = preFilter[0]?.["Filtro_ID_Local_Entrega"]?.value;
    const linhaLocal = locaisEntrega.find((item) => {
      const label = String(Object.values(item)[1] || "");
      const cnpjLabel = label.match(/\d{14}/)?.[0];
      return cnpjLabel === cnpjSelecionado;
    });
    const idLocalEntrega = linhaLocal ? Object.values(linhaLocal)[0] : null;
    const idTipoVeiculo = preFilter[0]?.["Filtro_ID_Veiculo"]?.value;
    const idCategoria = preFilter[0]?.["Filtro_ID_Categoria"]?.value;
    const idTipoEntrega = preFilter[0]?.["Filtro_ID_Tipo_Entrega"]?.value;
    const idUsuario = userProfile?.ID_Usuario;
    return { listaNotas, idLocalEntrega, idTipoVeiculo, idCategoria, idTipoEntrega, idUsuario };
  };

  const handleValidarAgendamento = async () => {
    const { listaNotas, idLocalEntrega, idTipoVeiculo, idCategoria, idTipoEntrega, idUsuario } = buildParamsBase();

    const params = {
      1: listaNotas,
      2: idLocalEntrega,
      3: idTipoVeiculo,
      4: idCategoria,
      5: idTipoEntrega,
    }

    const paramsValidacao = {
      ...params,
      6: null,
      7: idUsuario,
    };

    const paramsAgenda = {
      ...params,
      6: idUsuario,
    };

    let validResult = [];

    try {
      dispatch(isLoading(true));
      const [respValidacao, respAgenda, respHorarios] = await Promise.all([
        BizinBackend.executeProcedure(paramsValidacao, "FRONT_Workspace_DF_OT0030_Validar", csrfToken, access_token),
        BizinBackend.executeProcedure(paramsAgenda, "SRM_Agendamento_Verifica_Agenda_Disponivel", csrfToken, access_token),
        BizinBackend.executeProcedure({ 1: idLocalEntrega }, "SRM_Agendamentos_Verifica_Se_Empresa_Permite_Agendar_Primeiro_Horario_Disponivel", csrfToken, access_token),
      ]);

      if (respValidacao) {
        const result = respValidacao?.data || respValidacao?.resultset_1 || (Array.isArray(respValidacao) ? respValidacao : []);
        validResult = Array.isArray(result) ? result : [];
        setValidacaoResults(validResult);
      }

      if (respAgenda) {
        const result = respAgenda?.data || respAgenda?.resultset_1 || (Array.isArray(respAgenda) ? respAgenda : []);
        setAgendaDisponivel(Array.isArray(result) ? result : []);
      }

      if (respHorarios) {
        const resHor = respHorarios?.data || respHorarios?.resultset_1 || (Array.isArray(respHorarios) ? respHorarios : []);
        const linha = Array.isArray(resHor) ? resHor[0] : null;
        const valor = linha ? Object.values(linha)[0] : 0;
        setshowSchedules(Number(valor) !== 1);
      }
      setValidacaoExecutada(true);
      return validResult;
    } catch (error) {
      console.log("erro ao validar agendamento", error);
    } finally {
      dispatch(isLoading(false));
    }

  };

  const confirmarCriacaoAgendamento = async () => {
    if (!dataAgendaSelecionada) return;
    const { listaNotas, idLocalEntrega, idTipoVeiculo, idCategoria, idTipoEntrega, idUsuario } = buildParamsBase();

    const ano = dataAgendaSelecionada.getFullYear();
    const mes = String(dataAgendaSelecionada.getMonth() + 1).padStart(2, "0");
    const dia = String(dataAgendaSelecionada.getDate()).padStart(2, "0");
    const dataFmt = `${ano}${mes}${dia}`;
    const horaFmt = horaAgendaSelecionada || "";

    const paramsCriar = {
      1: listaNotas,
      2: dataFmt,
      3: horaFmt,
      4: idLocalEntrega,
      5: idUsuario,
      6: idTipoVeiculo,
      7: idCategoria,
      8: idTipoEntrega,
      9: "",
    };

    setCriandoAgendamento(true);
    try {
      const resp = await BizinBackend.executeProcedure(
        paramsCriar,
        "SRM_Agendamento_Criar",
        csrfToken,
        access_token,
      );

      const result =
        resp?.data || resp?.resultset_1 || (Array.isArray(resp) ? resp : []);
      const linhas = Array.isArray(result) ? result : [];
      const primeiro = linhas[0] || {};
      const sucesso = !!primeiro?.ID_Agendamento;

      setModalConfirmacaoAberto(false);
      setModalResultado({
        aberto: true,
        sucesso,
        id: primeiro?.ID_Agendamento || null,
        mensagem: sucesso ? "" : (primeiro?.Mensagem || "Não foi possível criar o agendamento."),
        detalhes: primeiro,
      });
    } catch (error) {
      console.log("erro SRM_Agendamento_Criar", error);
      setModalConfirmacaoAberto(false);
      setModalResultado({
        aberto: true,
        sucesso: false,
        id: null,
        mensagem: "Erro ao chamar o serviço de criação de agendamento.",
        detalhes: null,
      });
    } finally {
      setCriandoAgendamento(false);
    }
  };

  const fecharModalResultado = () => {
    const ok = modalResultado.sucesso;
    setModalResultado({ aberto: false, sucesso: false, mensagem: "", id: null, detalhes: null });
    if (ok) {
      setStep(1);
      setPreFilter([]);
      setLocaisEntrega([]);
      setNotasGrid([]);
      setNotasSelecionadas([]);
      setNotasPesquisadas(false);
      setValidacaoResults([]);
      setValidacaoExecutada(false);
      setAgendaDisponivel([]);
      setDataAgendaSelecionada(null);
      setHoraAgendaSelecionada(null);
    }
  };

  useEffect(() => {
    const destinoSelecionado = preFilter[0]?.["Filtro_ID_Empresa_Destino"]?.value;

    const loadLocais = async () => {
      try {
        const resp = await BizinBackend.executeProcedure(
          { 1: userProfile.ID_Usuario, 2: destinoSelecionado },
          "SRM_Agendamento_Local_Entrega",
          csrfToken,
          access_token,
        );

        const result = resp?.data?.resultset_1 || resp?.resultset_1 || (Array.isArray(resp) ? resp : []);
        setLocaisEntrega(Array.isArray(result) ? result : []);
      } catch (error) {
        console.log("erro ao carregar locais de entrega", error);
      }
    };

    loadLocais();
  }, [userProfile?.ID_Usuario, csrfToken, access_token]);

  useEffect(() => {
    if (step !== 3) return

    const origem = preFilter[0]?.["Filtro_ID_Empresa_Origem"]?.value;
    const destino = preFilter[0]?.["Filtro_ID_Empresa_Destino"]?.value;
    const cnpj = preFilter[0]?.["Filtro_ID_Local_Entrega"]?.value;
    if (!destino) return;

    const hoje = new Date();
    const hojeBR = `${String(hoje.getDate()).padStart(2, "0")}/${String(hoje.getMonth() + 1).padStart(2, "0")}/${hoje.getFullYear()}`;
    setPreFilter((state) => [
      {
        ...state[0],
        ...(!state[0]?.Filtro_Data_Inicio
          ? { Filtro_Data_Inicio: { value: hojeBR, field: "De" } }
          : {}),
        ...(!state[0]?.Filtro_Data_Termino
          ? { Filtro_Data_Termino: { value: hojeBR, field: "Até" } }
          : {}),
      },
    ]);

    const extract = (resp) =>
      resp?.data || resp?.resultset_1 || (Array.isArray(resp) ? resp : []);

    const firstAsOption = (arr) => {
      if (!Array.isArray(arr) || arr.length === 0) return null;
      const item = arr[0];
      const vals = Object.values(item);
      if (vals.length < 2) return null;
      return { value: vals[0], label: vals[1] };
    };

    const loadStep3 = async () => {
      try {
        const [respCat, respTipo, respVeic] = await Promise.all([
          origem
            ? BizinBackend.executeProcedure(
              { 1: destino, 2: origem },
              "CUA_Get_Categorias_Parceria",
              csrfToken,
              access_token,
            )
            : Promise.resolve(null),
          BizinBackend.executeProcedure(
            { 1: destino },
            "FRONT_Workspace_DF_OT0030_Lista_Tipo_Entrega",
            csrfToken,
            access_token,
          ),
          cnpj
            ? BizinBackend.executeProcedure(
              { 1: destino, 2: cnpj },
              "SRM_Get_Conhecimento_Transporte_Veiculos",
              csrfToken,
              access_token,
            )
            : Promise.resolve(null),
        ]);

        respTipo.map((item) => {
          item.value = item.ID_Tipo_Entrega;
          item.label = item.Descricao_Entrega;
          delete item.ID_Tipo_Entrega;
          delete item.Descricao_Entrega;
        })
        respVeic.map((item) => {
          item.value = item.ID_Tipo_Veiculo;
          item.label = item.Descricao_Veiculo;
          delete item.ID_Tipo_Veiculo;
          delete item.Descricao_Veiculo;
        })
        respCat.map((item) => {
          item.value = item.ID_Categoria;
          item.label = item.Descricao;
          delete item.ID_Categoria;
          delete item.Descricao;
        })
        setComboBoxTiposEntregaOptions(respTipo);
        setComboBoxVeiculosOptions(respVeic);
        setComboBoxCategoriasOptions(respCat);

        const firstCat = firstAsOption(extract(respCat));
        const firstTipo = firstAsOption(extract(respTipo));
        const firstVeic = firstAsOption(extract(respVeic));

        setPreFilter((state) => [
          {
            ...state[0],
            ...(firstCat && !state[0]?.Filtro_ID_Categoria
              ? { Filtro_ID_Categoria: firstCat }
              : {}),
            ...(firstTipo && !state[0]?.Filtro_ID_Tipo_Entrega
              ? { Filtro_ID_Tipo_Entrega: firstTipo }
              : {}),
            ...(firstVeic && !state[0]?.Filtro_ID_Veiculo
              ? { Filtro_ID_Veiculo: firstVeic }
              : {}),
          },
        ]);
      } catch (error) {
        console.log("erro ao carregar defaults do agendamento", error);
      }
    };

    loadStep3();
  }, [step]);

  const dataBRtoUS = (dataStr) => {
    if (!dataStr) return dataStr;
    const [dia, mes, ano] = String(dataStr).split("/");
    if (!dia || !mes || !ano) return dataStr;
    return `${mes}-${dia}-${ano}`;
  };

  const blockedFlags = validacaoResults.filter(
    (v) => (v?.Tipo_Mensagem || "").trim().toUpperCase() === "E",
  );

  const warningFlags = validacaoResults.filter(
    (v) => (v?.Tipo_Mensagem || "").trim().toUpperCase() === "A",
  );

  const successFlags = validacaoResults.filter((v) => {
    const tipo = (v?.Tipo_Mensagem || "").trim().toUpperCase();
    return tipo !== "E" && tipo !== "A" && tipo !== "W";
  });

  const canAdvance =
    notasSelecionadas.length > 0 &&
    validacaoExecutada &&
    blockedFlags.length === 0;

  const handleGetDataStep3 = async () => {
    try {
      dispatch(isLoading(true));
      setNotasPesquisadas(false);
      setValidacaoExecutada(false);
      const params = {
        1: userProfile?.ID_Usuario,
        2: preFilter[0]?.["Filtro_ID_Local_Entrega"]?.value,
        3: dataBRtoUS(preFilter[0]?.["Filtro_Data_Inicio"]?.value),
        4: dataBRtoUS(preFilter[0]?.["Filtro_Data_Termino"]?.value),
        5: ID_DOCUMENTO_GRUPO,
        6: preFilter[0]?.["Filtro_ID_Empresa_Origem"]?.value,
      };
      const resp = await BizinBackend.executeProcedure(
        params,
        "FRONT_Workspace_DF_OT0030_Obter_Notas_Fiscais",
        csrfToken,
        access_token,
      );

      const rows = resp?.data || resp?.resultset_1 || (Array.isArray(resp) ? resp : []);
      setNotasGrid(Array.isArray(rows) ? rows : []);
      setNotasPesquisadas(true);
    } catch (e) {
      console.log("erro ao buscar notas", e);
    } finally {
      dispatch(isLoading(false));
    }
  }

  const handleCheckIsBlocked = async () => {
    const empresaOrigem = preFilter[0]?.["Filtro_ID_Empresa_Origem"]?.value;
    const resp = await BizinBackend.executeProcedure(
      { 1: empresaOrigem },
      "EDI_FINANC_Contrato_Obter_Status_Bloqueio",
      csrfToken,
      access_token,
    )

    if (resp?.length > 0) {
      const isBlocked = resp[0]?.Bloqueio_Acesso === "S"
      setIsBlocked(isBlocked)
      return isBlocked
    }
  }

  const handleGetDataStep2 = async () => {
    const destinoSelecionado = preFilter[0]?.["Filtro_ID_Empresa_Destino"]?.value;
    try {
      dispatch(isLoading(true));
      setValidacaoExecutada(false);

      const isBlocked = await handleCheckIsBlocked();
      if (isBlocked) {
        setLocaisEntrega([]);
        return
      };

      const resp = await BizinBackend.executeProcedure(
        { 1: userProfile.ID_Usuario, 2: destinoSelecionado },
        "SRM_Agendamento_Local_Entrega",
        csrfToken,
        access_token,
      );
      const result = resp?.data?.resultset_1 || resp?.resultset_1 || (Array.isArray(resp) ? resp : []);
      setLocaisEntrega(Array.isArray(result) ? result : []);
    } catch (error) {
      console.log("erro ao carregar locais de entrega", error);
    } finally {
      dispatch(isLoading(false));
    }
  };

  const handleNextStep = async (nextStep) => {
    switch (nextStep) {
      case 2:
        await handleGetDataStep2();
        setStep(2);
        break;
      case 3:
        await handleGetDataStep3();
        setStep(3);
        break;
    }
  }

  console.log("preFilter: ", preFilter);


  return (
    <div className="vh-100 p-0">
      <div className="bg-white mb-3 card-content shadow-card p-4" style={{ display: [1, 2].includes(step) ? 'block' : 'none' }}>
        <div className="row">
          <div className="col pb-2">
            <h3 className="text-color-azul2 font-size-20 fw-semibold">Informações do Local de Retirada</h3>
          </div>
        </div>

        <div className="row d-flex align-items-end">
          <div className="col-12 col-lg-5 pe-lg-3">
            <TranspaleStringToComponente
              elementId={"ID_Empresa_Origem"}
              elementProps={{
                value: '',
                type: 'Combobox',
                title: "Empresa Origem",
                id: "Filtro_ID_Empresa_Origem",
                isDisabled: false,
                procedure: "FRONT_Componente_Combo_Empresas ",
                procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'ORIGEM', 'NF']
              }}
              preFilter={preFilter}
              onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
            />
          </div>
          <div className="col-12 col-lg-5 px-lg-0 pe-md-0">
            <TranspaleStringToComponente
              elementId={"ID_Empresa_Destino"}
              elementProps={{
                value: '',
                type: 'Combobox',
                title: "Empresa Destino",
                id: "Filtro_ID_Empresa_Destino",
                isDisabled: false,
                procedure: "FRONT_Componente_Combo_Empresas",
                procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'DESTINO', 'NF']
              }}
              preFilter={preFilter}
              onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
            />
          </div>
          <div className="col-12 col-lg-2 text-lg-end">
            <button className="btn btn-primary-dark text-white font-size-16 fw-semibold w-100" onClick={() => handleNextStep(2)} >Pesquisar</button>
          </div>
        </div>

        <div className="mt-4" style={{ display: step === 2 ? 'block' : 'none' }}>
          <div className="row">
            <div className="col pb-2">
              <h3 className="text-color-azul2 font-size-20 fw-semibold">Selecione o Local de Entrega</h3>
            </div>
          </div>
          <div className="row d-flex align-items-stretch">
            {locaisEntrega.map((item, i) => {
              const vals = Object.values(item);
              const label = String(vals[1] ?? "");
              const cnpjMatch = label.match(/\d{14}/);
              const value = cnpjMatch ? cnpjMatch[0] : String(vals[0]);
              return (
                <div key={i} className="col-lg-4 col-md-6 col-12 mb-3">
                  <TranspaleStringToComponente
                    elementId={`ID_Local_Entrega_${value}`}
                    elementProps={{
                      value: value,
                      type: 'Radio',
                      checked: preFilter[0]?.["Filtro_ID_Local_Entrega"]?.value === value,
                      title: label,
                      id: "Filtro_ID_Local_Entrega",
                      name: "Local_Entrega"
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                  />
                </div>
              );
            })}
            <div className="col-12 d-flex justify-content-end mb-3">
              <button
                className="btn btn-primary-dark text-white font-size-16 fw-semibold"
                onClick={() => setStep(3)}
              >
                Próximo
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: step === 3 ? 'block' : 'none' }}>
        <Row className="mb-4">
          <Col lg={6} className="pe-lg-2">
            <div className="bg-white mb-3 card-content shadow-card p-4 h-100">
              <div className="row">
                <div className="col pb-2">
                  <h3 className="text-color-azul2 font-size-20 fw-semibold">
                    Filtro de Notas por Período
                  </h3>
                </div>
              </div>
              <div className="row d-flex align-items-end">
                <div className="form-custom01-filter col-12 col-md-6 pe-lg-0">
                  <TranspaleStringToComponente
                    elementId={"Filtro_Data_Inicio"}
                    elementProps={{
                      value: "",
                      type: "Date",
                      title: "De",
                      id: "Filtro_Data_Inicio"
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) =>
                      setPreFilter((state) => [{ ...state[0], ...filters }])
                    }
                  />
                </div>
                <div className="form-custom01-filter col-12 col-md-6">
                  <TranspaleStringToComponente
                    elementId={"Filtro_Data_Termino"}
                    elementProps={{
                      value: "",
                      type: "Date",
                      title: "Até",
                      id: "Filtro_Data_Termino"
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) =>
                      setPreFilter((state) => [{ ...state[0], ...filters }])
                    }
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12 d-flex justify-content-end">
                  <button
                    className="btn btn-primary-dark text-white font-size-16 fw-semibold"
                    onClick={() => {
                      handleNextStep(3);
                    }}
                  >
                    Pesquisar
                  </button>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} className="ps-lg-2">
            <div className="bg-white mb-3 card-content shadow-card p-4 h-100">
              <div className="row">
                <div className="col pb-2">
                  <h3 className="text-color-azul2 font-size-20 fw-semibold">
                    Informações do Agendamento
                  </h3>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 pe-md-2">
                  <TranspaleStringToComponente
                    elementId={"ID_Veiculo"}
                    elementProps={{
                      value: "",
                      type: "Combobox",
                      title: "Selecione o Veículo",
                      id: "Filtro_ID_Veiculo",
                      isDisabled: false,
                      dataOptions: comboBoxVeiculosOptions
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                  />
                </div>
                <div className="col-12 col-md-6 ps-md-2">
                  <TranspaleStringToComponente
                    elementId={"ID_Tipo_Entrega"}
                    elementProps={{
                      value: "",
                      type: "Combobox",
                      title: "Tipo de Entrega",
                      id: "Filtro_ID_Tipo_Entrega",
                      isDisabled: false,
                      dataOptions: comboBoxTiposEntregaOptions
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                  />
                </div>
                <div className="col-12">
                  <TranspaleStringToComponente
                    elementId={"ID_Categoria"}
                    elementProps={{
                      value: "",
                      type: "Combobox",
                      title: "Selecione a Categoria",
                      id: "Filtro_ID_Categoria",
                      isDisabled: false,
                      dataOptions: comboBoxCategoriasOptions
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {notasPesquisadas && notasGrid.length === 0 ? (
          <div className="my-3">
            <Alert className="border-0 m-0" style={{ backgroundColor: "#FECE2226" }}>
              <div className="row p-2 px-3">
                <div className="col-auto p-0 pe-3">
                  <i className="fas fa-exclamation-triangle text-warning font-size-24"></i>
                </div>
                <div className="col p-0">
                  <p className="text-color-amarelo2 fw-semibold font-size-14 p-0 m-0 mb-2">ATENÇÃO</p>
                  <p className="text-color-amarelo2 font-size-14 p-0 m-0">
                    Nenhuma nota fiscal encontrada para o período e local selecionado: <strong>{preFilter[0]?.["Filtro_Data_Inicio"]?.value} à {preFilter[0]?.["Filtro_Data_Termino"]?.value}.</strong>
                  </p>
                </div>
              </div>
            </Alert>
          </div>
        ) : (
          <TableSimple
            dataKey={"ID_Arquivo"}
            data={notasGrid}
            columnsList={[
              { field: "Numero_NF", header: "Numero da Nota Fiscal", sort: true },
              { field: "Valor_Total_NF", header: "Valor", sort: true },
              { field: "Peso_Bruto_Total", header: "Peso", sort: true },
              { field: "Data_Emissao", header: "Data Emissão", sort: true },
            ]}
            enableTotalRows
            enableCheckbox={true}
            callbackCheckboxSelected={(selected) => {
              setNotasSelecionadas(selected || []);
              setValidacaoExecutada(false);
              setValidacaoResults([]);
            }}
          />
        )}
      </div>


      {step === 3 && validacaoExecutada && notasPesquisadas && (
        <div className="bg-white mb-3 card-content shadow-card p-4">
          <div className="row">
            <div className="col-12 pb-2">
              <h3 className="text-color-azul2 font-size-20 fw-semibold">Validação de disponibilidade</h3>
            </div>
          </div>
          <div className="row d-flex align-items-stretch gap-3 px-4">

            {successFlags.length > 0 && (
              <div className={`col p-0 m-0`}>
                <Alert className="border-0 m-0" style={{ backgroundColor: '#4BB54326' }}>
                  <div className="row p-2 px-3">
                    <div className="col-auto p-0 pe-3">
                      <i className="fas fa-circle-check text-success font-size-24"></i>
                    </div>
                    <div className="col p-0">
                      <p className="text-color-verde2 fw-semibold font-size-14 p-0 m-0 mb-2">APTAS PARA AGENDAMENTO</p>
                      {successFlags.map((item, i) => (
                        <p className="text-color-cinza4 font-size-14 p-0 m-0" key={i}>
                          {item?.Mensagem_Card}
                        </p>
                      ))}
                    </div>
                  </div>
                </Alert>
              </div>
            )}
            {blockedFlags.length > 0 &&
              (
                <div className="col p-0">
                  <Alert className="border-0 m-0 h-100" style={{ backgroundColor: "#EC221F26" }}>
                    <div className="row p-2 px-3">
                      <div className="col-auto p-0 pe-3">
                        <i className={`fas fa-circle-xmark text-color-vermelho2 font-size-24`}></i>
                      </div>
                      <div className="col p-0">
                        <p className={"text-color-vermelho2 fw-semibold font-size-14 p-0 m-0 mb-2"}>BLOQUEIO</p>
                        {blockedFlags.map((item, i) => (
                          <p key={item?.id_resultado} className={`text-color-vermelho2 font-size-14 p-0 m-0`}>{(item?.Mensagem_Card || "").trim()}</p>
                        )
                        )}

                      </div>
                    </div>
                  </Alert>
                </div>
              )
            }
            {warningFlags.length > 0 &&
              (
                <div className="col p-0">
                  <Alert className="border-0 m-0 h-100" style={{ backgroundColor: "#FECE2226" }}>
                    <div className="row p-2 px-3">
                      <div className="col-auto p-0 pe-3">
                        <i className={`fas fa-circle-xmark text-warning font-size-24`}></i>
                      </div>
                      <div className="col p-0">
                        <p className={"text-color-amarelo2 fw-semibold font-size-14 p-0 m-0 mb-2"}>REVISÃO</p>
                        {warningFlags.map((item, i) => (
                          <p key={item?.id_resultado} className={`text-color-amarelo2 font-size-14 p-0 m-0`}>{(item?.Mensagem_Card || "").trim()}</p>
                        )
                        )}

                      </div>
                    </div>
                  </Alert>
                </div>
              )
            }

          </div>
        </div>
      )}

      {step === 3 && (
        <div className="row mt-2 mb-3">
          <div className="col-6 d-flex justify-content-start">
            <button
              className="btn bg-white border border-color-cinza2 text-color-azul1 fw-bold px-4"
              onClick={() => {
                setStep(step - 1)
                setNotasGrid([])
                setNotasSelecionadas([])
              }}
            >
              Voltar
            </button>
          </div>
          <div className="col-6 d-flex justify-content-end gap-2">
            <button
              className={`btn fw-semibold px-4 ${notasSelecionadas.length > 0
                ? "btn-primary-dark text-white"
                : "disabled bg-color-cinza2 text-color-cinza4 border border-color-cinza2"
                }`}
              disabled={notasSelecionadas.length === 0}
              onClick={handleValidarAgendamento}
            >
              Verificar disponibilidade
            </button>
            <button
              className={`btn fw-semibold px-4 ${canAdvance
                ? "btn-primary-dark text-white"
                : "disabled bg-color-cinza2 text-color-cinza4 border border-color-cinza2"
                }`}
              disabled={!canAdvance}
              onClick={() => setStep(4)}
            >
              Próximo
            </button>
          </div>
        </div>
      )}

      {step === 4 && (() => {
        const datasUnicas = Array.from(
          new Set(agendaDisponivel.map((a) => a?.Data_Agenda).filter(Boolean)),
        ).map((d) => {
          const [dia, mes, ano] = d.split("/");
          return new Date(`${ano}-${mes}-${dia}T00:00:00`);
        });

        const horariosDisponiveis = dataAgendaSelecionada
          ? agendaDisponivel
            .filter((a) => {
              const [dia, mes, ano] = (a?.Data_Agenda || "").split("/");
              const d = new Date(`${ano}-${mes}-${dia}T00:00:00`);
              return d.getTime() === dataAgendaSelecionada.getTime();
            })
            .map((a) => a?.Hora_Agenda)
          : [];

        const horariosUnicos = Array.from(new Set(horariosDisponiveis));

        const dataHoraSelecionada =
          dataAgendaSelecionada && horaAgendaSelecionada
            ? `${dataAgendaSelecionada.toLocaleDateString("pt-BR")} ${showSchedules ? `às ${horaAgendaSelecionada}` : ''}`
            : "—";

        return (
          <>
            <Row className="mb-3">
              <Col lg={5} md={6} sm={12} className="mb-3 pe-md-0">
                <div className="bg-white card-content shadow-card p-4 h-100">
                  <h3 className="text-color-azul2 font-size-20 fw-semibold mb-3">
                    Selecione a data de entrega
                  </h3>
                  <CalendarMultiMonth
                    numberOfMonths={2}
                    selectedDates={dataAgendaSelecionada ? [dataAgendaSelecionada] : []}
                    availableDates={datasUnicas}
                    onChange={(dates) => {
                      const dataSelected = dates[dates.length - 1] || null;
                      setDataAgendaSelecionada(dataSelected);

                      if (!showSchedules && dataSelected) {
                        const dataStr = `${String(dataSelected.getDate()).padStart(2, "0")}/${String(dataSelected.getMonth() + 1).padStart(2, "0")}/${dataSelected.getFullYear()}`;
                        const primeiro = agendaDisponivel.find((a) => a?.Data_Agenda === dataStr);
                        setHoraAgendaSelecionada(primeiro?.Hora_Agenda || null);
                      } else {
                        setHoraAgendaSelecionada(null);
                      }
                    }}
                  />
                </div>
              </Col>

              {showSchedules && horariosDisponiveis.length > 0 && (
                <Col lg={3} className="mb-3 p-0">
                  <div className="bg-white card-content shadow-card p-4">
                    <h3 className="text-color-azul2 font-size-20 fw-semibold mb-3">
                      Selecione o horário de entrega
                    </h3>
                    <div className="row g-2">
                      {horariosDisponiveis.map((h) => {
                        const habilitado = horariosUnicos.some((x) => (x || "").startsWith(h.slice(0, 2)));
                        const selecionado = horaAgendaSelecionada === h;
                        return (
                          <div key={h} className="col-4">
                            <button
                              type="button"
                              disabled={!habilitado}
                              onClick={() => setHoraAgendaSelecionada(h)}
                              className={`btn w-100 fw-semibold border-0 rounded-3 fw-regular ${selecionado
                                ? "btn-primary-dark text-white"
                                : habilitado
                                  ? "bg-color-azul410 text-color-azul2"
                                  : "text-color-cinza4"
                                }`}
                              style={{ height: 44, ...(!habilitado && !selecionado && { backgroundColor: "#F1F1F1" }) }}
                            >
                              {h}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Col>
              )}

              <Col lg={4} md={6} className="mb-3">
                <div className="bg-white card-content shadow-card p-4">
                  <h3 className="text-color-azul2 font-size-20 fw-semibold mb-3">
                    Confira o agendamento
                  </h3>
                  <Row>
                    <Col md={4} className="mb-3">
                      <div className="text-muted small">Tipo de Veículo</div>
                      <div className="fw-semibold text-color-cinza5">
                        {preFilter[0]?.["Filtro_ID_Veiculo"]?.label || "—"}
                      </div>
                    </Col>
                    <Col md={4} className="mb-3">
                      <div className="text-muted small">Tipo de Entrega</div>
                      <div className="fw-semibold text-color-cinza5">
                        {preFilter[0]?.["Filtro_ID_Tipo_Entrega"]?.label || "—"}
                      </div>
                    </Col>
                    <Col md={4} className="mb-3">
                      <div className="text-muted small">Data e Hora de Entrega</div>
                      <div className="fw-semibold text-color-cinza5">{dataHoraSelecionada}</div>
                    </Col>
                    <Col md={4} className="mb-3">
                      <div className="text-muted small">Categoria</div>
                      <div className="fw-semibold text-color-cinza5">
                        {preFilter[0]?.["Filtro_ID_Categoria"]?.label || "—"}
                      </div>
                    </Col>
                    <Col md={4} className="mb-3">
                      <div className="text-muted small">Destino</div>
                      <div className="fw-semibold text-color-cinza5">
                        {preFilter[0]?.["Filtro_ID_Empresa_Destino"]?.label || "—"}
                      </div>
                    </Col>
                    <Col md={4} className="mb-3">
                      <div className="text-muted small">Local de Entrega</div>
                      <div className="fw-semibold text-color-cinza5 text-break">
                        {preFilter[0]?.["Filtro_ID_Local_Entrega"]?.field || "—"}
                      </div>
                    </Col>
                  </Row>
                  <Alert className="border-0 m-0 mt-2" style={{ backgroundColor: "#FECE2226" }}>
                    <div className="row p-2 px-3">
                      <div className="col-auto p-0 pe-3">
                        <i className="fas fa-exclamation-triangle text-warning font-size-20"></i>
                      </div>
                      <div className="col p-0">
                        <span className="text-color-amarelo2 fw-semibold font-size-14">
                          ATENÇÃO:
                        </span>{" "}
                        <span className="text-color-amarelo2 font-size-14">
                          Respeite os horários do local de entrega.
                        </span>
                      </div>
                    </div>
                  </Alert>
                </div>
              </Col>
            </Row>

            <div className="row mt-2 mb-3">
              <div className="col-6 d-flex justify-content-start">
                <button
                  className="btn bg-white border border-color-cinza2 text-color-azul1 fw-bold px-4"
                  onClick={() => setStep(step - 1)}
                >
                  Voltar
                </button>
              </div>
              <div className="col-6 d-flex justify-content-end">
                <button
                  className={`btn fw-semibold px-4 ${dataAgendaSelecionada && horaAgendaSelecionada
                    ? "btn-primary-dark text-white"
                    : "disabled bg-color-cinza2 text-color-cinza4 border border-color-cinza2"
                    }`}
                  disabled={!dataAgendaSelecionada || !horaAgendaSelecionada}
                  onClick={() => setModalConfirmacaoAberto(true)}
                >
                  Finalizar agendamento
                </button>
              </div>
            </div>
          </>
        );
      })()}

      <NotificationModal
        isOpen={modalConfirmacaoAberto}
        type="warning"
        titleCustom="Deseja criar o agendamento?"
        message="Ao clicar em 'Confirmar' o agendamento será criado."
        confirmButton
        onClose={() => !criandoAgendamento && setModalConfirmacaoAberto(false)}
        onConfirm={confirmarCriacaoAgendamento}
      />

      <NotificationModal
        isOpen={modalResultado.aberto}
        type={modalResultado.sucesso ? "success" : "error"}
        titleCustom={modalResultado.sucesso ? "Sucesso!" : "Não foi possível criar"}
        message={
          modalResultado.sucesso
            ? `O agendamento #${modalResultado.id} foi criado com sucesso!`
            : modalResultado.mensagem
        }
        onClose={fecharModalResultado}
      />

      <NotificationModal
        isOpen={isBlocked}
        type={"warning"}
        titleCustom={`Sua conta está temporariamente bloqueada`}
        message={`Identificamos uma pendência financeira em sua conta. Por esse motivo, seu acesso foi bloqueado temporariamente.`}
        onClose={() => setIsBlocked(false)}
      >
        <div className="bg-color-branco3 p-3 rounded-2 mb-3">
          <p className="color-cinza5 mb-3 font-size-14">Para regularizar a situação e restabelecer o acesso, entre em contato pelo e-mail <strong className="fw-semibold text-color-azul4 text-decoration-underline">financeiro@businessintegrator.com.br</strong>.</p>
          <p className="color-cinza5 font-size-14 m-0 p-0">Nossa equipe está à disposição para esclarecer dúvidas e ajudar na resolução da pendência o mais rápido possível.</p>
        </div>
      </NotificationModal>
    </div>
  )
}

export default GridBody;